'use client';

import styled from 'styled-components';
import pinLogo from 'public/address_pin.svg';
import Image from 'next/image';
import { H2, LargeBodyText } from '@/lib/StyledComponents/Typography';
import { mq } from '@/lib/StyledComponents/mq';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.75rem 0;

  h2 {
    margin-bottom: 0.625rem;
  }

  ${mq('laptop')} {
    padding: 7.5rem 0;

    h2 {
      font-size: 2.25rem;
    }

    p {
      font-size: 1.25rem;
    }
  }
`;

type Props = {
  title: string;
  name: string;
  street: string;
  postalCodeAndCity: string;
};

export const AddressContainer = ({
  name,
  postalCodeAndCity,
  street,
  title,
}: Props) => {
  return (
    <Container>
      <Image src={pinLogo} alt="pin-logo" height={44} width={44} />
      <H2>{title}</H2>
      <LargeBodyText $fontWeight="medium">{name}</LargeBodyText>
      <LargeBodyText $fontWeight="medium">{street}</LargeBodyText>
      <LargeBodyText $fontWeight="medium">{postalCodeAndCity}</LargeBodyText>
    </Container>
  );
};
